import {
  AspectRatio,
  Flex,
  Grid,
  Skeleton,
  SkeletonText,
  Stack,
  VStack,
} from '@chakra-ui/react';
import { PrizeTicket } from '~/types/resources/prizeTicket';
import { PrizeTicketItem } from './PrizeTicketItem';

type Props = {
  availablePrizeTickets: PrizeTicket[];
  onOpen: () => void;
  setSelectedTicketId: (newSelectedTicketId: string) => void;
};

export const PrizeTicketList: React.FC<Props> = (props: Props) => {
  const groupedTickets = props.availablePrizeTickets.reduce(
    (acc, ticket) => {
      if (!acc[ticket.ticket_id]) {
        acc[ticket.ticket_id] = [];
      }
      acc[ticket.ticket_id].push(ticket);
      return acc;
    },
    {} as Record<string, PrizeTicket[]>
  );
  return (
    <Flex flexDir="column" w="full">
      <Grid templateColumns="repeat(3, 1fr)" gap={0} justifyContent="center">
        {Object.values(groupedTickets).map((tickets, index) => {
          return (
            <PrizeTicketItem
              key={`prizeTicket_${index}`}
              availablePrizeTicket={tickets[0]}
              ticketLength={tickets.length}
              onOpen={props.onOpen}
              setSelectedTicketId={props.setSelectedTicketId}
            />
          );
        })}
      </Grid>
    </Flex>
  );
};

export const PrizeTicketListSkeleton: React.FC = () => {
  return (
    <VStack w="full" m="16px" gap="16px">
      <Stack w="full" px="16px" align="center">
        <SkeletonText height="36px" noOfLines={1} w="240px" />
      </Stack>
      <Stack w="full" p="16px" bgColor="blank">
        <Grid templateColumns="repeat(3, 1fr)" gap="8px" mx="8px">
          {[...Array(8)].map((_, index) => {
            return (
              <AspectRatio ratio={1} key={index}>
                <Skeleton h="full" w="full" />
              </AspectRatio>
            );
          })}
        </Grid>
      </Stack>
      <SkeletonText height="42px" w="full" mt="16px" noOfLines={1} />
      <SkeletonText height="42px" w="full" noOfLines={1} />
    </VStack>
  );
};
